import * as ngCore from '@angular/core'

import { AtnDsTableStore } from '../../../store'

import * as clipboard from './clipboard'
import * as excel from './excel'
import * as settings from './settings'

@ngCore.Component({
  imports: [clipboard.Component, excel.Component, settings.Component],
  selector: 'widget-container-actions',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  // NOTE: only public for template purposes
  public readonly _store = ngCore.inject(AtnDsTableStore)

  /**
   * Initiates the creation of a new table entity, in case:
   *  TODO: - creation mode is false, should be implemented
   * - creation mode is true, it will dispatch edit action
   * - otherwise it will call creation callback
   */
  public addClickHandler(): void {
    this._store.creationEntityHandling()
  }
}
